import { render, staticRenderFns } from "./ContainerConsents.vue?vue&type=template&id=1a9a830e"
import script from "./ContainerConsents.vue?vue&type=script&lang=ts"
export * from "./ContainerConsents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports